(() => {
  const initialize = () => {
    const burger = document.querySelector('.header_burger');
    const mobileMenu = document.querySelector('.mobile-category-menu');
    if (burger && mobileMenu && !burger.dataset.mirandaBound) {
      burger.dataset.mirandaBound = 'true';
      burger.addEventListener('click', () => {
        mobileMenu.classList.toggle('open');
        document.body.classList.toggle('overflow-hidden', mobileMenu.classList.contains('open'));
        document.querySelector('.section-header')?.classList.remove('shopify-section-header-hidden');
      });
    }
    const button = document.querySelector('#search-icon');
    const search = document.querySelector('.search-wrapper');
    const toggler = document.querySelector('.search-toggler');
    if (button && search && !button.dataset.mirandaBound) {
      button.dataset.mirandaBound = 'true';
      button.addEventListener('click', () => {
        search.classList.toggle('open');
        const open = search.classList.contains('open');
        const input = document.querySelector('#header_search');
        if (open) input?.focus(); else input?.blur();
        toggler?.children.item(0)?.classList.toggle('display-none', open);
        toggler?.children.item(1)?.classList.toggle('display-none', !open);
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
